module.exports = __webpack_public_path__ + "media/images/icon_menu-644a80c84fe1186e873cdda0ee236e57.svg";